import { ROLES } from 'config';

const reportEditConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('report', {
      url: '/report/{id}?v',
      template: '<report-edit></report-edit>',
      params: {
        extras: null,
      },
      access: {
        loginRequired: true,
        roles: [ROLES.USER, ROLES.ADMIN],
      },
      resolve: {
        // meredicteParams: (CatalogService) => CatalogService.getMeredicteParams(),
      },
    });
};

export default reportEditConfig;



// WEBPACK FOOTER //
// ./src/modules/report-edit/report-edit.config.js